import { saveData } from "./indexdbManager"
export async function handleInitalAudienceEdit(audience) {
  let editAud = JSON.parse(JSON.stringify(audience))
  await saveData("auienceBuilder", 'abForm', 'loadAudience', editAud)
  await saveData("auienceBuilder", 'abForm', 'formData', {
    "id": editAud.id,
    "activeChannel": editAud.activeChannel,
    "title": editAud.title,
    "description": editAud.description,
    "includeList": editAud.includeList,
    "excludeList": editAud.excludeList,
    "audienceSegments": editAud.audienceSegments,
    "thresholdSelection": editAud.thresholdSelection,
    "isWholeOrLocation": editAud.isWholeOrLocation,
    "targetSpend": editAud.targetSpend,
    "targetQuanity": editAud.targetQuanity,
    "audienceRatio": editAud.audienceRatio,
    "isGiveMeTheBest": editAud.isGiveMeTheBest,
    "minProspects": editAud.minProspects,
    "audienceBreakdown": editAud.audienceBreakdown,
  })
  window.location.href = '/build-audience'
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/caching/handleInitalAudienceEdit.js